export enum FieldTypeKind {
    STRING = 0,
    GUID = 1,
    BOOLEAN = 2,
    DATE = 3,
    LONG = 4,
    ANY = 5,
    MODEL = 6,
    VIRTUAL = 7,
    ENUM = 8,
    HTML = 9,
    MONEY = 10,
    DECIMAL = 11,
    TELEPHONE = 12,
    TEXT = 13,
    POINT = 14,
    FILE = 15,
    MONGOID = 16,
    BLOB = 17,
    BIGINT = 18,
    SEARCH = 19,
    FLOAT = 20,
    DATEONLY = 21
}
